import { readCookie } from "./GeneralHelpers";

const ENABLE_ADOBE_TARGET_FLAG = "enableAdobeTargetScript";
const enableAdobeTarget =
  readCookie(ENABLE_ADOBE_TARGET_FLAG) || window.location.hash === `#${ENABLE_ADOBE_TARGET_FLAG}`;

const AdobeTargetPreScript = {
  load() {
    if (enableAdobeTarget) {
      console.log("enableAdobeTarget flag is on");
      // Remove hash if exists
      history.pushState("", document.title, `${window.location.pathname}${window.location.search}`);

      // Prehiding snippet for Adobe Target with asynchronous Launch deployment
      /* eslint-disable */
      (function(g, b, d, f) {
        (function(a, c, d) {
          if (a) {
            const e = b.createElement("style");
            e.id = c;
            e.innerHTML = d;
            a.appendChild(e);
          }
        })(b.getElementsByTagName("head")[0], "at-body-style", d);
        setTimeout(() => {
          const a = b.getElementsByTagName("head")[0];
          if (a) {
            const c = b.getElementById("at-body-style");
            c && a.removeChild(c);
          }
        }, f);
      })(window, document, "body {opacity: 0 !important}", 3e3);
      /* eslint-enable */
    }
  },
};

export default AdobeTargetPreScript;
